import { toJS } from 'mobx'
import { v4 as uuidv4, validate } from 'uuid'
import { KIND } from './constants'

// 将图片列表处理为 url width height type 的数组
export const formatDesignImage = (images = []) => {
  if (!images) {
    return []
  }
  const ret = images.map(item => ({
    url: item?.url,
    width: item?.width,
    height: item?.height,
    type: item?.type ?? 'image',
    markId: item?.markId,
    id: item?.id ?? uuidv4()
  }))
  return ret
}

/**
 * @title 将数据处理成 未分区 舞台仪式区 迎宾签到区 婚礼细节 4个区域图片数组
 * @param {object} unsign 未分区
 * @param {object} stage 舞台仪式区
 * @param {object} check 迎宾签到
 * @param {object} detail 婚礼细节
 */
export const formatSiteImage = (
  unsign = {},
  stage = {},
  check = {},
  detail = {}
) => {
  const retUnSign = formatDesignImage(unsign?.imgs)
  const retStage = formatDesignImage(stage?.imgs)
  const retCheck = formatDesignImage(check?.imgs)
  const retDetail = formatDesignImage(detail?.imgs)
  return {
    unsign: retUnSign,
    stage: retStage,
    check: retCheck,
    detail: retDetail
  }
}

/**
 * @title 反格式化 4个 区域图片数组
 */
export const unFormatSiteImage = ({
  unsign = [],
  stage = [],
  check = [],
  detail = []
}) => {
  const retUnSign = {
    kind: KIND['NoSetting'],
    imgs: formatDesignImage(unsign)
  }
  const retStage = {
    kind: KIND['StageCeremony'],
    imgs: formatDesignImage(stage)
  }
  const retCheck = {
    kind: KIND['WelcomeSign'],
    imgs: formatDesignImage(check)
  }
  const retDetail = {
    kind: KIND['WeddingDetail'],
    imgs: formatDesignImage(detail)
  }

  return {
    unsign: retUnSign,
    stage: retStage,
    check: retCheck,
    detail: retDetail
  }
}

/**
 * @title 获取不同区域的标签
 */

export const getCaseImageTag = (caseImageTag, kind) => {
  if (!toJS(caseImageTag) || !kind) {
    return []
  }
  // 映射表，后端给过来的是type 1 - 舞台仪式 2 - 迎宾签到 3 - 婚礼细节
  // 前端数据处理后标记用kind 3 - 舞台仪式 4 - 迎宾签到 5 - 婚礼细节
  const mapping = {
    [KIND['StageCeremony']]: 1,
    [KIND['WelcomeSign']]: 2,
    [KIND['WeddingDetail']]: 3
  }

  return toJS(caseImageTag).find(f => f.type === mapping[kind])?.children ?? []
}

/**
 * @title 将caseContent 处理成前端所需要的格式
 */

export const formatCaseContent = (details = []) => {
  // 设计稿数据块
  let designDiagram = {
    kind: KIND['DesignDiagram'],
    imgs: []
  }
  // 设计构思数据块
  let designConcept = {
    kind: KIND['DesignConcept'],
    text: undefined
  }
  // 舞台仪式区
  let stageCeremony = {
    kind: KIND['StageCeremony'],
    imgs: [],
    title: ''
  }
  // 迎宾签到区
  let welcomeSign = {
    kind: KIND['WelcomeSign'],
    imgs: [],
    title: ''
  }
  // 婚礼细节
  let weddingDetail = {
    kind: KIND['WeddingDetail'],
    imgs: [],
    title: ''
  }
  // 未设置分区
  let noSetting = {
    kind: KIND['NoSetting'],
    imgs: [],
    title: ''
  }
  details.forEach(f => {
    if (f.kind === 4) {
      designDiagram.imgs.push({
        markId: f.markId,
        id: f.id ?? uuidv4(),
        kind: f.kind,
        width: f.content?.width,
        height: f.content?.height,
        url: f.content?.media_path
      })
    }
    if (f.kind === 5) {
      designConcept.text = f.content?.text
      designConcept.id = f.id
    }

    if (f.kind === 1) {
      switch (f.image_area_id) {
        case 0:
          noSetting.title = f.image_area_name
          noSetting.imgs.push({
            markId: f.mark_id,
            id: f.id ?? uuidv4(),
            kind: f.kind,
            width: f.content?.width,
            height: f.content?.height,
            url: f.content?.media_path
          })
          break
        case 1:
          // 舞台仪式区
          stageCeremony.title = f.image_area_name
          stageCeremony.imgs.push({
            markId: f.mark_id,
            id: f.id ?? uuidv4(),
            kind: f.kind,
            width: f.content?.width,
            height: f.content?.height,
            url: f.content?.media_path
          })
          break
        case 2:
          // 舞台仪式区
          welcomeSign.title = f.image_area_name
          welcomeSign.imgs.push({
            markId: f.mark_id,
            id: f.id ?? uuidv4(),
            kind: f.kind,
            width: f.content?.width,
            height: f.content?.height,
            url: f.content?.media_path
          })
          break
        case 3:
          // 舞台仪式区
          weddingDetail.title = f.image_area_name
          weddingDetail.imgs.push({
            markId: f.mark_id,
            id: f.id ?? uuidv4(),
            kind: f.kind,
            width: f.content?.width,
            height: f.content?.height,
            url: f.content?.media_path
          })
          break
        default:
          noSetting.title = f.image_area_name
          noSetting.imgs.push({
            markId: f.mark_id,
            id: f.id ?? uuidv4(),
            kind: f.kind,
            width: f.content?.width,
            height: f.content?.height,
            url: f.content?.media_path
          })
          break
      }
    }
  })
  const ret = []
  designDiagram.imgs.length ? ret.push(designDiagram) : ret.push(undefined)
  designConcept.text == null ? ret.push(undefined) : ret.push(designConcept)
  ret.push(stageCeremony)
  ret.push(welcomeSign)
  ret.push(weddingDetail)
  ret.push(noSetting)
  return ret
}

/**
 * @title 将前端数据处理成后端需要的格式提交
 */
export const unFormatCaseContent = (details = []) => {
  const ret = []
  details.forEach(f => {
    switch (f?.kind) {
      case KIND['DesignDiagram']:
        // 特殊处理，如果areaImage为空数组，则push进去一个kind=4空占位，便于提交时校验
        const areaImage = formatAreaImage(f?.imgs, 4)
        if (!areaImage?.length) {
          ret.push({
            kind: 4,
            content: undefined
          })
        }
        ret.push(...areaImage)
        break
      case KIND['DesignConcept']:
        ret.push({
          kind: 5,
          id: f.id,
          content: {
            text: f.text
          }
        })
        break
      case KIND['StageCeremony']:
        ret.push(...formatAreaImage(f?.imgs, 1, 1))
        break
      case KIND['WelcomeSign']:
        ret.push(...formatAreaImage(f?.imgs, 1, 2))
        break
      case KIND['WeddingDetail']:
        ret.push(...formatAreaImage(f?.imgs, 1, 3))
        break
      case KIND['NoSetting']:
        ret.push(...formatAreaImage(f?.imgs, 1, 0))
        break
      default:
        break
    }
  })

  return ret
}

const formatAreaImage = (imgs = [], kind, areaId) => {
  return imgs.map(item => ({
    kind: kind,
    id: validate(item?.id) ? undefined : item?.id,
    content: {
      width: item?.width,
      height: item?.height,
      mediaPath: item?.url
    },
    imageAreaId: areaId,
    markId: item?.markId
  }))
}
